
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/espana-tcs",
      function () {
        return require("private-next-pages/espana-tcs/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/espana-tcs"])
      });
    }
  